module.exports = __webpack_public_path__ + "img/check.fbb74494.svg";